import { Select, SelectProps } from 'antd';
import { useGetAllTransportTypesQuery } from 'app/api';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const TransportTypeSelect: FC<IProps> = props => {
  const { t } = useTranslation();

  const {
    data: allTransportTypes,
    isFetching: isAllTransportTypesLoading,
  } = useGetAllTransportTypesQuery();

  const transportTypeOptions: IOption[] | undefined = allTransportTypes?.map(
    tranportType => ({
      value: tranportType.id,
      label: tranportType.name,
    }),
  );
  return (
    <Select
      placeholder={t('TransportTypeSelect.Placeholder', 'Type')}
      options={transportTypeOptions}
      loading={isAllTransportTypesLoading}
      {...props}
    />
  );
};

export default TransportTypeSelect;
